import React from 'react';
import NumberFormat from 'react-number-format';

interface Props {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  allowNegative?: boolean;
  symbol: string;
}

export const MoneyInput = React.forwardRef<any, Props>((props, ref) => {
  const { onChange, symbol, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandsGroupStyle="thousand"
      prefix={symbol ?? ' '}
      thousandSeparator
      decimalScale={2}
    />
  );
});
